var config = module.exports = {};

config.name = 'SimpleApp';

config.dev = true;
config.live = false;

config.repl = true;

config.minify = false;
config.forceMinify = false;

config.populateAll = false;
config.autoIncludePartials = true;

config.IP = '127.0.0.0';
